import React from "react";

const Footer = () => {
  return (
    <div className="bg-[#4c4a66] flex justify-center text-[#ccd6f6]">
      <p>&copy; 2022 JorgeSosa</p>
    </div>
  );
};

export default Footer;
